module.exports = __webpack_public_path__ + "static/4-36992e0397dfd8164f864f55a9e5223e.png";